export default __webpack_public_path__ + "static/media/MyHeritage.602886ae.png";